(() => {
 'use strict';
 const init = root => {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  root.classList.add('s2t-cart--enhanced');
  const form = root.querySelector('form');
  if (!form) return;
  let busy = false;
  const status = root.querySelector('[data-cart-status]');
  const error = root.querySelector('[data-cart-error]');
  const setBusy = value => {
   busy = value;
   root.setAttribute('aria-busy', String(value));
   root.querySelectorAll('[data-cart-checkout]').forEach(b => b.disabled = value);
   root.querySelectorAll('[data-cart-wallets]').forEach(el => el.inert = value);
  };
  // Render one unedited five-star review from Judge.me's current featured feed.
  // The inert template prevents a second carousel, product photos or vendor styles appearing in the cart.
  const source = root.querySelector('[data-cart-review-source]');
  const review = source && [...source.content.querySelectorAll('.jdgm-carousel-item')].find(item => {
   const rating = item.querySelector('.jdgm-carousel-item__review-rating');
   const body = item.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim();
   return rating?.getAttribute('aria-label') === '5 stars' && body && body.length <= 450;
  });
  if (review) {
   root.querySelector('[data-review-body]').textContent = review.querySelector('.jdgm-carousel-item__review-body').textContent.trim();
   root.querySelector('[data-review-author]').textContent = review.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim() || 'S2 customer';
   root.querySelector('[data-cart-review]').hidden = false;
  }
  const render = html => {
   const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-s2t-cart]');
   if (!next) throw new Error('Cart display could not refresh. Please reload the page to confirm your cart.');
   if (!next.querySelector('form')) { window.location.reload(); return; }
   root.querySelectorAll('[data-s2t-region]').forEach(region => {
    const replacement = next.querySelector(`[data-s2t-region="${region.dataset.s2tRegion}"]`);
    if (replacement) region.innerHTML = replacement.innerHTML;
   });
   const count = next.querySelector('[data-s2t-region="count"]')?.textContent.replace(/\D/g, '');
   if (count) document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = count);
  };
  const update = async (line, quantity, focusAction) => {
   if (busy) return;
   const key = line.dataset.key;
   const oldQuantity = Number(line.dataset.quantity);
   if (quantity === oldQuantity) return;
   const index = [...root.querySelectorAll('[data-cart-line]')].indexOf(line);
   setBusy(true); error.hidden = true; status.textContent = 'Updating your cart…';
   try {
    const response = await fetch(`${root.dataset.changeUrl}.js`, {
     method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
     body: JSON.stringify({id:key, quantity, sections:[root.dataset.sectionId], sections_url:root.dataset.cartUrl})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'This quantity could not be updated. Please check the available quantity.');
    const html = data.sections?.[root.dataset.sectionId];
    if (!html) throw new Error('Your change was saved, but the cart display could not refresh. Please reload before checkout.');
    render(html);
    status.textContent = quantity === 0 ? 'Item removed. Your subtotal has been updated.' : 'Quantity and subtotal updated.';
    const rows = [...root.querySelectorAll('[data-cart-line]')];
    const row = rows.find(el => el.dataset.key === key) || rows[Math.min(index,rows.length - 1)];
    const target = row?.querySelector(focusAction || '[data-cart-quantity]') || root.querySelector('[data-cart-checkout]');
    target?.focus({preventScroll:true});
   } catch (e) {
    // Never retry a cart mutation after an uncertain network response.
    const input = line.querySelector('[data-cart-quantity]');
    if (input) input.value = oldQuantity;
    error.textContent = `${e.message || 'We could not confirm this change.'} Refresh the cart before continuing.`;
    const refresh = document.createElement('a'); refresh.href = root.dataset.cartUrl; refresh.textContent = ' Refresh cart'; error.append(refresh);
    error.hidden = false; status.textContent = '';
    // A network failure can occur after Shopify saves the change. Keep checkout gated until reload.
    root.dataset.needsRefresh = 'true';
   } finally {
    setBusy(false);
    if (root.dataset.needsRefresh) { root.querySelectorAll('[data-cart-checkout]').forEach(b=>b.disabled=true); root.querySelectorAll('[data-cart-wallets]').forEach(el=>el.inert=true); }
   }
  };
  root.addEventListener('click', event => {
   const remove = event.target.closest('[data-cart-remove]');
   const stepper = event.target.closest('[data-qty-step]');
   if (!remove && !stepper) return;
   event.preventDefault();
   if (busy || root.dataset.needsRefresh) return;
   const line = event.target.closest('[data-cart-line]');
   if (remove) return void update(line,0,'[data-cart-remove]');
   const input = line.querySelector('[data-cart-quantity]');
   const step = Number(input.step) || 1;
   const quantity = Number(input.value) + Number(stepper.dataset.qtyStep) * step;
   if (quantity < Number(input.min) || (input.max && quantity > Number(input.max))) return;
   update(line,quantity,`[data-qty-step="${stepper.dataset.qtyStep}"]`);
  });
  root.addEventListener('change', event => {
   const input = event.target.closest('[data-cart-quantity]');
   if (!input) return;
   const line = input.closest('[data-cart-line]');
   if (busy || root.dataset.needsRefresh) { input.value=line.dataset.quantity; return; }
   if (!input.checkValidity()) { input.reportValidity(); input.value=line.dataset.quantity; return; }
   update(line,Number(input.value));
  });
  form.addEventListener('submit',event=>{
   if (busy || root.dataset.needsRefresh) { event.preventDefault(); status.textContent = busy ? 'Please wait while your cart updates.' : 'Please refresh your cart before checkout.'; }
  });
 };
 document.querySelectorAll('[data-s2t-cart]').forEach(init);
 document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-s2t-cart]')));
 window.addEventListener('pageshow',event=>{ if(event.persisted) window.location.reload(); });
})();
